export default __webpack_public_path__ + "static/media/fin.c43e31b6.png";